export default __webpack_public_path__ + "static/media/pinkleaf_small.9c0e5aa7.jpg";